import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.block_type = parseInt(payload.block_type, 10)
  payload.use_free_balance = parseInt(payload.use_free_balance, 10)
  payload.use_min_balance = parseInt(payload.use_min_balance, 10)
  payload.service_id = parseInt(payload.service_id, 10)
  payload.priority = parseInt(payload.priority, 10)
  payload.min_balance = parseFloat(payload.min_balance)
  payload.max_duration = parseInt(payload.max_duration, 10)
  payload.is_enabled = parseInt(payload.is_enabled, 10)
  payload.interval_duration = parseInt(payload.interval_duration, 10)
  payload.id = parseInt(payload.id, 10)
  payload.group_id = parseInt(payload.group_id, 10)
  payload.free_balance = parseFloat(payload.free_balance)
  payload.min_duration = parseInt(payload.min_duration, 10)
  payload.self_unlock = parseInt(payload.self_unlock, 10)
}

var state = {
  voluntarySuspensionSettings: [],
  allVoluntarySuspensions: []
}

var getters = {
  VOLUNTARY_SUSPENSION_SETTINGS: (state) => {
    return state.voluntarySuspensionSettings
  },
  ALL_VOLUNTARY_SUSPENSIONS: (state) => {
    return state.allVoluntarySuspensions
  }
}

var mutations = {
  SET_VOLUNTARY_SUSPENSION_SETTINGS: (state, payload) => {
    state.voluntarySuspensionSettings = payload
  },
  SET_ALL_VOLUNTARY_SUSPENSIONS: (state, payload) => {
    state.allVoluntarySuspensions = payload
  }
}

var actions = {
  GET_VOLUNTARY_SUSPENSION_SETTINGS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/voluntary_suspensions')
    if (result.status === 200) {
      context.commit('SET_VOLUNTARY_SUSPENSION_SETTINGS', result.data)
    }
  },
  GET_VOLUNTARY_SUSPENSIONS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/all_voluntary_suspensions')
    if (result.status === 200) {
      context.commit('SET_ALL_VOLUNTARY_SUSPENSIONS', result.data)
    }
  },
  CREATE_VOLUNTARY_SUSPENSION_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/voluntary_suspensions', payload)
  },
  UPDATE_VOLUNTARY_SUSPENSION_SETTINGS: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/voluntary_suspensions', payload)
  },
  DELETE_VOLUNTARY_SUSPENSION_SETTINGS: (context, payload) => {
    return axiosInstance.delete('/settings/voluntary_suspensions?voluntary_suspension_id=' + payload)
  },
  DELETE_VOLUNTARY_SUSPENSION: (context, payload) => {
    return axiosInstance.delete('/settings/customer_voluntary_suspension?id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/voluntarySuspension.js